export const headerMenuItemStyles = {
	root: { display: 'flex', alignItems: 'center', gap: 1, lineHeight: 1 }
};
